/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useContext, useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TablePagination from '@material-ui/core/TablePagination'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import { makeStyles } from '@material-ui/core/styles'

import FlashContext from '../../components/contexts/FlashContext'
import Loading from '../../components/loading/Loading'
import api from '../../service/axios/api'
import { formatCurrency } from '../../service/utils'

// ─────────────────────────────────────────────────────────────
// Estilos
// ─────────────────────────────────────────────────────────────
const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(2) },

  filtersRow: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
  },
  formControl: { minWidth: 140 },

  // Cards de resumo
  summaryRow: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    flexWrap: 'wrap',
  },
  card: {
    flex: 1,
    minWidth: 180,
    padding: theme.spacing(2),
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  cardLabel: {
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    color: '#888',
  },
  cardValue: {
    fontSize: '1.4rem',
    fontWeight: 700,
  },
  cardEntradas: { borderTop: '4px solid #2e7d32' },
  cardSaidas:   { borderTop: '4px solid #c62828' },
  cardSaldo:    { borderTop: '4px solid #1565c0' },

  entradasColor: { color: '#2e7d32' },
  saidasColor:   { color: '#c62828' },
  saldoPositivo: { color: '#1565c0' },
  saldoNegativo: { color: '#c62828' },

  // Tabs
  tabs: {
    marginBottom: theme.spacing(2),
    borderBottom: '1px solid #e0e0e0',
  },
  tabEntradas: { '&.Mui-selected': { color: '#2e7d32', fontWeight: 700 } },
  tabSaidas:   { '&.Mui-selected': { color: '#c62828', fontWeight: 700 } },
  tabCentros:  { '&.Mui-selected': { color: '#1565c0', fontWeight: 700 } },

  // Tabela
  tableHeader: {
    backgroundColor: '#f5f5f5',
    '& th': { fontWeight: 700, fontSize: '0.82rem', color: '#555' },
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(6),
    color: '#aaa',
  },
  saldoPositivoCell: { color: '#2e7d32', fontWeight: 700 },
  saldoNegativoCell: { color: '#c62828', fontWeight: 700 },
}))

// ─────────────────────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────────────────────
const formatDate = (date) =>
  date ? new Date(date).toLocaleDateString('pt-BR') : '-'

// ─────────────────────────────────────────────────────────────
// Componente
// ─────────────────────────────────────────────────────────────
export default function CashFlow() {
  const classes = useStyles()
  const { notifyError } = useContext(FlashContext)

  const today = new Date()
  const currentYear  = today.getFullYear()
  const currentMonth = (today.getMonth() + 1).toString()

  const monthOptions = [
    { value: 'all', label: 'Todos' },
    { value: '1',  label: 'Janeiro' },
    { value: '2',  label: 'Fevereiro' },
    { value: '3',  label: 'Março' },
    { value: '4',  label: 'Abril' },
    { value: '5',  label: 'Maio' },
    { value: '6',  label: 'Junho' },
    { value: '7',  label: 'Julho' },
    { value: '8',  label: 'Agosto' },
    { value: '9',  label: 'Setembro' },
    { value: '10', label: 'Outubro' },
    { value: '11', label: 'Novembro' },
    { value: '12', label: 'Dezembro' },
  ]

  const yearOptions = Array.from({ length: 5 }, (_, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString(),
  }))

  // ── Estado ──
  const [loading, setLoading]     = useState(false)
  const [activeTab, setActiveTab] = useState(0) // 0=Entradas 1=Saídas 2=Por Centro
  const [month, setMonth]         = useState(currentMonth)
  const [year, setYear]           = useState(currentYear.toString())

  // Dados da API
  const [totalEntradas, setTotalEntradas]   = useState(0)
  const [totalSaidas, setTotalSaidas]       = useState(0)
  const [saldoFinal, setSaldoFinal]         = useState(0)
  const [entradas, setEntradas]             = useState([])
  const [saidas, setSaidas]                 = useState([])
  const [porCentro, setPorCentro]           = useState([])

  // Paginação entradas
  const [pageEntradas, setPageEntradas]     = useState(0)
  const [totalEntDocs, setTotalEntDocs]     = useState(0)

  // Paginação saídas
  const [pageSaidas, setPageSaidas]         = useState(0)
  const [totalSaiDocs, setTotalSaiDocs]     = useState(0)

  const [itens, setItens] = useState(10)

  // ── Busca ──
  const searchData = async (pEnt = pageEntradas, pSai = pageSaidas) => {
    setLoading(true)
    try {
      const response = await api.cashFlow.getAll({
        year,
        month,
        page: activeTab === 0 ? pEnt + 1 : pSai + 1,
        limit: itens,
        cost_center: true, // sempre traz agrupamento por centro
      })

      // eslint-disable-next-line      
      const { entradas: ent, saidas: sai, saldo_final, por_centro_de_custo } = response.data

      setTotalEntradas(ent.total)
      setTotalSaidas(sai.total)
      setSaldoFinal(saldo_final)

      setEntradas(ent.paginated.docs)
      setTotalEntDocs(ent.paginated.total)

      setSaidas(sai.paginated.docs)
      setTotalSaiDocs(sai.paginated.total)

      // eslint-disable-next-line
      setPorCentro(por_centro_de_custo || [])
    } catch (error) {
      notifyError(error.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    searchData()
  }, [month, year, itens, pageEntradas, pageSaidas, activeTab])

  // ─────────────────────────────────────────────────────────
  // Render tabela Entradas
  // ─────────────────────────────────────────────────────────
  const renderEntradas = () => (
    <TableContainer component={Paper} elevation={1}>
      <Table size="small">

        <TableHead className={classes.tableHeader}>
          <TableRow>
            <TableCell>Descrição</TableCell>
            <TableCell>Centro de Custo</TableCell>
            <TableCell>Vencimento</TableCell>
            <TableCell align="right">Valor</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {entradas.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} className={classes.emptyState}>
                Nenhuma entrada encontrada no período.
              </TableCell>
            </TableRow>
          ) : (
            entradas.map((row) => (
              <TableRow key={row.id} hover>
                <TableCell>{row.description || '-'}</TableCell>
                <TableCell>{row.CostCenter?.name || '-'}</TableCell>
                <TableCell>{formatDate(row.due_date)}</TableCell>
                <TableCell align="right" className={classes.entradasColor}>
                  {formatCurrency(parseFloat(row.amount || 0))}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={totalEntDocs}
        rowsPerPage={itens}
        page={pageEntradas}
        onPageChange={(_, p) => setPageEntradas(p)}
        onRowsPerPageChange={(e) => { setItens(parseInt(e.target.value, 10)); setPageEntradas(0) }}
        labelRowsPerPage="Linhas por página"
        labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
      />
    </TableContainer>
  )

  // ─────────────────────────────────────────────────────────
  // Render tabela Saídas
  // ─────────────────────────────────────────────────────────
  const renderSaidas = () => (
    <TableContainer component={Paper} elevation={1}>
      <Table size="small">
        <TableHead className={classes.tableHeader}>
          <TableRow>
            <TableCell>Categoria</TableCell>
            <TableCell>Centro de Custo</TableCell>
            <TableCell>Vencimento</TableCell>
            <TableCell align="right">Valor</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {saidas.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} className={classes.emptyState}>
                Nenhuma saída encontrada no período.
              </TableCell>
            </TableRow>
          ) : (
            saidas.map((row) => (
              <TableRow key={row.id} hover>
                <TableCell>{row.category || '-'}</TableCell>
                <TableCell>{row.CostCenter?.name || '-'}</TableCell>
                <TableCell>{formatDate(row.due_date)}</TableCell>
                <TableCell align="right" className={classes.saidasColor}>
                  {formatCurrency(parseFloat(row.amount || 0))}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={totalSaiDocs}
        rowsPerPage={itens}
        page={pageSaidas}
        onPageChange={(_, p) => setPageSaidas(p)}
        onRowsPerPageChange={(e) => { setItens(parseInt(e.target.value, 10)); setPageSaidas(0) }}
        labelRowsPerPage="Linhas por página"
        labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
      />
    </TableContainer>
  )

  // ─────────────────────────────────────────────────────────
  // Render tabela Por Centro de Custo
  // ─────────────────────────────────────────────────────────
  const renderPorCentro = () => (
    <TableContainer component={Paper} elevation={1}>
      <Table size="small">
        <TableHead className={classes.tableHeader}>
          <TableRow>
            <TableCell>Centro de Custo</TableCell>
            <TableCell align="right">Entradas</TableCell>
            <TableCell align="right">Saídas</TableCell>
            <TableCell align="right">Saldo</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {porCentro.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} className={classes.emptyState}>
                Nenhum centro de custo encontrado no período.
              </TableCell>
            </TableRow>
          ) : (
            porCentro.map((row, idx) => (
              // eslint-disable-next-line
              <TableRow key={idx} hover>
                <TableCell>{row.cost_center}</TableCell>
                <TableCell align="right" className={classes.entradasColor}>
                  {formatCurrency(row.entradas || 0)}
                </TableCell>
                <TableCell align="right" className={classes.saidasColor}>
                  {formatCurrency(row.saidas || 0)}
                </TableCell>
                <TableCell
                  align="right"
                  className={
                    row.saldo >= 0
                      ? classes.saldoPositivoCell
                      : classes.saldoNegativoCell
                  }
                >
                  {formatCurrency(row.saldo || 0)}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )

  // ─────────────────────────────────────────────────────────
  // Render principal
  // ─────────────────────────────────────────────────────────
  return (
    <>
      <Loading open={loading} msg="Carregando fluxo de caixa..." />

      <Grid container className={classes.root}>

        {/* Título */}
        <Grid item xs={12} style={{ marginBottom: 16 }}>
          <h3 style={{ margin: 0 }}>Fluxo de Caixa</h3>
        </Grid>

        {/* Filtros */}
        <Grid item xs={12} className={classes.filtersRow}>
          <FormControl variant="outlined" size="small" className={classes.formControl}>
            <InputLabel>Mês</InputLabel>
            <Select
              value={month}
              onChange={(e) => { setMonth(e.target.value); setPageEntradas(0); setPageSaidas(0) }}
              label="Mês"
            >
              {monthOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl variant="outlined" size="small" className={classes.formControl}>
            <InputLabel>Ano</InputLabel>
            <Select
              value={year}
              onChange={(e) => { setYear(e.target.value); setPageEntradas(0); setPageSaidas(0) }}
              label="Ano"
            >
              {yearOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Cards de resumo */}
        <Grid item xs={12} className={classes.summaryRow}>
          <Paper className={`${classes.card} ${classes.cardEntradas}`} elevation={1}>
            <span className={classes.cardLabel}>Total de Entradas</span>
            <span className={`${classes.cardValue} ${classes.entradasColor}`}>
              {formatCurrency(totalEntradas)}
            </span>
          </Paper>

          <Paper className={`${classes.card} ${classes.cardSaidas}`} elevation={1}>
            <span className={classes.cardLabel}>Total de Saídas</span>
            <span className={`${classes.cardValue} ${classes.saidasColor}`}>
              {formatCurrency(totalSaidas)}
            </span>
          </Paper>

          <Paper className={`${classes.card} ${classes.cardSaldo}`} elevation={1}>
            <span className={classes.cardLabel}>Saldo Final</span>
            <span
              className={`${classes.cardValue} ${
                saldoFinal >= 0 ? classes.saldoPositivo : classes.saldoNegativo
              }`}
            >
              {formatCurrency(saldoFinal)}
            </span>
          </Paper>
        </Grid>

        {/* Tabs */}
        <Grid item xs={12}>
          <Tabs
            value={activeTab}
            onChange={(_, v) => setActiveTab(v)}
            className={classes.tabs}
            TabIndicatorProps={{
              style: {
                backgroundColor:
                  activeTab === 0 ? '#2e7d32' : '#1565c0',
              },
            }}
          >
            <Tab label={`Entradas (${totalEntDocs})`} className={classes.tabEntradas} />
            <Tab label={`Saídas (${totalSaiDocs})`}   className={classes.tabSaidas} />
            <Tab label="Por Centro de Custo"           className={classes.tabCentros} />
          </Tabs>
        </Grid>

        {/* Conteúdo das tabs */}
        <Grid item xs={12}>
          {activeTab === 0 && renderEntradas()}
          {activeTab === 1 && renderSaidas()}
          {activeTab === 2 && renderPorCentro()}
        </Grid>

      </Grid>
    </>
  )
}
